export enum PromotionCodeScope {
  Subscription = "scope.subscription",
  Redeem = "scope.redeem",
}
